// UI
import FulfillmentOrderForm from '@/components/fulfillment_orders/create/FulfillmentOrderForm'
import ScrollableScreen from '@/components/ui/ScrollableScreen'

// Hooks
import { useAxiosApi } from '@/hooks/useAxiosApi'
import useMe from '@/hooks/useMe'

// Next
import { useNavigate } from 'react-router-dom'

export default function FulfillmentOrderCreate() {
    const navigate = useNavigate()
    const { requestPost } = useAxiosApi()
    const { isAdmin, isReady } = useMe()

    // Default source location: admins start on Atelier Paris (6), non-admins
    // are locked to 1 (LocationSelect only exposes location 1 to them anyway)
    const defaultLocationId = isAdmin ? 6 : 1

    const handleSubmit = async (data) => {
        const response = await requestPost('/fulfillment-orders', {
            location_id: data.location_id,
            to_location_id: data.to_location_id,
            consignee: data.consignee,
            fulfill_at: data.fulfill_at,
            warranties_mode: data.warranties_mode,
            incoterm: data.incoterm,
            lines: data.lines.map((line) => ({
                variant_id: line.variant_id,
                component_id: line.component_id,
                quantity: line.total_quantity,
                unit_price: line.unit_price_initial,
            })),
        })

        if (response?.data?.id) {
            navigate(`/fulfillment_orders/${response.data.id}`)
        }
    }

    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Nouvelle demande de préparation',
        },
    ]

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <div className="p-5 mx-auto max-w-[1200px]">
                {isReady && (
                    <FulfillmentOrderForm
                        initialLocationId={defaultLocationId}
                        onSubmit={handleSubmit}
                    />
                )}
            </div>
        </ScrollableScreen>
    )
}
